import { decodeEntities } from "@wordpress/html-entities";
import { useState, useEffect } from "@wordpress/element";

const { registerPaymentMethod } = window.wc.wcBlocksRegistry;

const { Spinner } = window.wc.blocksComponents;

const { getSetting } = window.wc.wcSettings;
const settings = getSetting("maddies_payment_data", {});
console.log(settings);
const label = decodeEntities(settings.title);

const Content = (props) => {
	console.log(props);

	const { eventRegistration, emitResponse } = props;
	const { onPaymentProcessing } = eventRegistration;

	const [coin, setCoin] = useState(
		settings?.coins?.length ? settings.coins[0] : null
	);
	const [coinPrice, setCoinPrice] = useState(null);
	const [loading, setLoading] = useState(false);

	const updateAmount = () => {
		const total = props.billing.cartTotal;

		setLoading(true);

		fetch(`${settings.url}/wc-api/coin-price`, {
			method: "POST",
			body: JSON.stringify({ total: total.value, coin: coin.id }),
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((res) => {
				setCoinPrice(res);
				setLoading(false);
			});
	};

	useEffect(() => {
		updateAmount();
	}, [coin]);

	useEffect(() => {
		updateAmount();
	}, [props.billing.cartTotal]);

	useEffect(() => {
		const unsubscribe = onPaymentProcessing(async () => {

			console.log(coin);

			return {
				type: emitResponse.responseTypes.SUCCESS,
				meta: {
					paymentMethodData: {
						coin_id: coin.id,
					},
				},
			};
		});
		return () => {
			unsubscribe();
		};
	}, [
		emitResponse.responseTypes.ERROR,
		emitResponse.responseTypes.SUCCESS,
		onPaymentProcessing,
	]);

	return (
		<div className="maddies-payment-wrapper">
			<p>{settings.description}</p>

			<div className="coin-selector">
				<label>Select a coin</label>
				<select name="" id="">
					{settings.coins.map((item, index) => {
						return (
							<option value={item.id} key={`coin_${index}`}>
								{item.coin}
							</option>
						);
					})}
				</select>
			</div>

			{loading && (
				<div className="loading-wrapper">
					<Spinner />
				</div>
			)}

			{!loading && coinPrice && (
				<div className="coin-price">
					<img src={coin.icon} alt="" />
					{coinPrice && <span>{coinPrice}</span>}
				</div>
			)}
		</div>
	);
};

const Label = (props) => {
	const { PaymentMethodLabel } = props.components;
	return <PaymentMethodLabel text={label} />;
};

registerPaymentMethod({
	name: "maddies_payment",
	label: <Label />,
	content: <Content />,
	edit: <Content />,
	canMakePayment: () => true,
	ariaLabel: "maddies",
	supports: {
		features: settings.supports,
	},
});
